import React from 'react'

const ContactSection: React.FC = () => {
  return (
    <section id='contact' className='contact-banner' style={{ position: 'relative', background: '#2e7d32', padding: '60px 0', width: '100%', overflow: 'hidden' }}>
      {/* Tło zdjęcie z overlayem */}
      <div style={{ position: 'absolute', inset: 0, zIndex: 0 }}>
        <img src='/assets/images/contact-bg.jpg' alt='tło' style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.25 }} />
        <div style={{ position: 'absolute', inset: 0, background: '#2e7d32', opacity: 0.85 }} />
      </div>
      <div className='container' style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div className='row' style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'stretch' }}>
          {/* Lewa kolumna */}
          <div className='col-lg-6 col-md-12' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '32px 24px', color: '#fff' }}>
            <h2 style={{ fontWeight: 700, fontSize: '2rem', color: '#fff', marginBottom: 18 }}>Masz pytania? Chcesz dołączyć do platformy? Skontaktuj się z nami – odpowiemy najszybciej jak to możliwe!</h2>
            <p style={{ color: '#fff', marginBottom: 32, fontSize: '1.15rem' }}>Wybierając jeden z naszych planów, zyskujesz nie tylko widoczność, ale konkretne narzędzia do osiągania realnych celów: większej liczby zapytań, lepszej konwersji i silniejszej obecności w branży!</p>
            {/* Miniaturka i podpis */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginTop: 18 }}>
              <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'green', overflow: 'hidden' }}>
                <img src='/assets/images/icons/zdjecie_kontakt.png' alt='miniaturka' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <div>
                <div style={{ fontWeight: 600, color: '#fff' }}>Ewa Chmielewska</div>
                <div style={{ color: '#fff', fontSize: '0.72rem', fontStyle: 'italic', marginTop: 2 }}>Marketing Manager</div>
                <div style={{ color: '#fff', fontSize: '0.82rem' }}>e.chmielewska@kreatlo.com</div>
              </div>
            </div>
          </div>
          {/* Prawa kolumna: formularz */}
          <div className='col-lg-6 col-md-12' style={{ background: '#fff', borderRadius: '4px', boxShadow: '0 4px 32px rgba(10,42,58,0.08)', padding: '40px 32px', margin: '16px 0', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <h3 style={{ fontWeight: 700, fontSize: '1.3rem', color: '#0e2b3d', marginBottom: 8 }}>Napisz do nas</h3>
            <p style={{ color: '#555', marginBottom: 24 }}>Jakie usługi lub pliki chcesz udostępnić branży projektowej?</p>
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  )
}

const ContactForm: React.FC = () => {
  return (
    <form>
      <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
        <input type='text' placeholder='Imię i nazwisko *' required style={{ flex: 1, padding: '12px', borderRadius: '4px', border: '1px solid #e0e0e0' }} />
        <input type='email' placeholder='Adres e-mail *' required style={{ flex: 1, padding: '12px', borderRadius: '4px', border: '1px solid #e0e0e0' }} />
      </div>
      <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
        <input type='text' placeholder='Nazwa firmy (opcjonalnie)' style={{ flex: 1, padding: '12px', borderRadius: '4px', border: '1px solid #e0e0e0' }} />
        <input type='text' placeholder='Strona www (opcjonalnie)' style={{ flex: 1, padding: '12px', borderRadius: '4px', border: '1px solid #e0e0e0' }} />
      </div>
      <div style={{ marginBottom: 16 }}>
        <input type='text' placeholder='Numer telefonu (opcjonalnie)' style={{ width: '100%', padding: '12px', borderRadius: '4px', border: '1px solid #e0e0e0' }} />
      </div>
      <div style={{ marginBottom: 16 }}>
        <textarea placeholder='Wiadomość' rows={4} style={{ width: '100%', padding: '12px', borderRadius: '4px', border: '1px solid #e0e0e0', resize: 'vertical' }} />
      </div>
      <div style={{ marginBottom: 18, display: 'flex', alignItems: 'center', gap: 8 }}>
        <input type='checkbox' id='privacy' required style={{ marginRight: 8 }} />
        <label htmlFor='privacy' style={{ fontSize: '0.98rem', color: '#555' }}>Akceptuję politykę prywatności i regulamin</label>
      </div>
      <button
        type='submit'
        className='tw-w-full tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors tw-bg-green hover:tw-bg-opacity-90 tw-text-white tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base'
      >
        Wyślij wiadomość
      </button>
    </form>
  )
}

export default ContactSection
